import { Box, Flex, Spacer, Text , Image} from "@chakra-ui/react";
import menu from "../../Assets/menu.svg";
import arrow from "../../Assets/leftArrow.png";
import digitLogo from "../../Assets/digit.png"
import { useNavigate } from "react-router-dom";
import { useDeviceType } from "app/hooks";
import { config } from "config";


export const Header = ({
  isHome,
  title,
  isHealthform,
}: {
  isHome?: boolean;
  title?: string;
  isHealthform?: boolean;
}) => {
  const navigate = useNavigate();
  const { isDesktop, isMobile } = useDeviceType();
  return (
    <>
      <header
        className={`w-full mx-auto shadow ${isHealthform ? "bg-[#F5F5F5]" : "bg-white"
          } py-2 fixed z-50 top-0`}
      >
        <div className="flex space-x-1 items-center px-4">
          <div className="my-auto">
            <Image src={config.siteLogo} h={isMobile?'10':'14'} className="w-auto" />
          </div>
          {/* <Text fontWeight={'medium'} fontSize={isMobile?'lg':'xl'}>IMT Alumni Association</Text> */}
        </div>
      </header>
      <Spacer h="20" />
    </>
  );
};

{/* {isHome && ( */ }
{/* <div className="my-auto px-4">
<img src={menu} className="h-6 w-auto " />
</div> */}
{/* )} */ }

{/* {!isHome && !isHealthform && (
          <Box position="relative">
            <Box
              position="absolute"
              left="3"
              className="top-1/2 -translate-y-1/2"
              onClick={() => navigate(-1)}
            >
              <img src={arrow} className="h-4 w-auto cursor-pointer" />
            </Box>
            <Text fontWeight="bold" padding={"2"} textAlign="center">
              {title}
            </Text>
          </Box>
        )}
        {isHealthform && (
          <>
            <Flex gap={"1"} justifyContent={"space-between"} w="90%" mx="auto">
              <Box
                position="absolute"
                left="3"
                className="top-1/2 -translate-y-1/2"
                onClick={() => navigate(-1)}
              >
                <img src={arrow} className="h-4 w-auto cursor-pointer" />
              </Box>
              <Text
                fontWeight="bold"
                paddingY={"4"}
                paddingLeft='6'
                textAlign="center"
                fontSize={isDesktop?'xl':'md'}
              >
                Good Health Declaration
              </Text>
              <Box>
                <img src={digitLogo} className="w-auto h-12 p-2" />
              </Box>
            </Flex>
          </>
        )} */}
